import type { SiteData, BracketData } from "../types";
import { flipArray, itemLast } from "./utils";

function setSeeds8(
  siteData: SiteData,
  brackets: BracketData,
  type: "winners" | "losers",
): SiteData {
  let seedCount = 1;
  const arr = brackets[type];
  for (let x = 0; x < arr.length; x += 2) {
    const songValues = [arr[x]!, arr[x + 1]!];
    siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
      "seed" + seedCount
    ] = songValues;
    seedCount += 1;
  }
  siteData.bracketsModeSettings.current2Seeds =
    siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
      "seed" + siteData.bracketsModeSettings.currentSeed
    ]!;
  return siteData;
}

export interface BracketScenarioResult {
  siteData: SiteData;
  brackets: BracketData;
  isFinal: boolean;
}

export function bracketScenario8(
  inputSiteData: SiteData,
  inputBrackets: BracketData,
  winner: number,
  loser: number,
): BracketScenarioResult {
  const siteData = structuredClone(inputSiteData);
  const brackets = structuredClone(inputBrackets);

  const { currentSeed, gameResults, currentRound } =
    siteData.bracketsModeSettings;
  const winnersRoundsSet1 = [1, 2, 3, 4];
  const losersRoundsSet1 = [5, 6];
  const winnersRoundSet2 = [7, 8];
  const losersRoundsSet2 = [9, 10, 11];
  const winnersRoundSet3 = [12];

  delete siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
    "seed" + currentSeed
  ];

  // 1, 2, 3 and 4 (Winners)
  if (winnersRoundsSet1.includes(currentRound)) {
    brackets.winners.push(winner);
    brackets.losers.push(loser);
    if (currentRound === itemLast(winnersRoundsSet1, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds8(siteData, brackets, "losers");
    } else {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
  }

  // 5 and 6 (Losers)
  if (losersRoundsSet1.includes(currentRound)) {
    gameResults.push(loser);
    const indexOfLoser = brackets.losers.indexOf(loser);
    brackets.losers.splice(indexOfLoser, 1, -1);
    if (currentRound === itemLast(losersRoundsSet1, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds8(siteData, brackets, "winners");
      brackets.losers = flipArray(brackets.losers);
    } else {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
    if (!brackets.losers.includes(winner)) {
      brackets.losers.push(winner);
    }
  }

  // 7 and 8 (Winners)
  if (winnersRoundSet2.includes(currentRound)) {
    if (brackets.winners.includes(loser)) {
      const loserIndex = brackets.winners.indexOf(loser);
      brackets.winners.splice(loserIndex, 1);
    }
    const negativeValue = brackets.losers.indexOf(-1);
    brackets.losers.splice(negativeValue, 1, loser);
    if (currentRound === itemLast(winnersRoundSet2, 1)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      brackets.losers = [...brackets.losers].reverse();
      setSeeds8(siteData, brackets, "losers");
    } else {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
  }

  // 9, 10 and 11 (Losers)
  if (losersRoundsSet2.includes(currentRound)) {
    gameResults.push(loser);
    let indexOfLoser = brackets.losers.indexOf(loser);
    brackets.losers.splice(indexOfLoser, 1);
    if (currentRound === itemLast(losersRoundsSet2, 2)) {
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds8(siteData, brackets, "losers");
    }
    if (currentRound === itemLast(losersRoundsSet2, 1)) {
      indexOfLoser = brackets.losers.indexOf(loser);
      brackets.losers.splice(indexOfLoser, 1, -1);
      siteData.bracketsModeSettings.currentSeed = 1;
      setSeeds8(siteData, brackets, "winners");
    } else if (currentRound === itemLast(losersRoundsSet2, 3)) {
      siteData.bracketsModeSettings.currentSeed += 1;
      siteData.bracketsModeSettings.current2Seeds =
        siteData.bracketsModeSettings.gameSeedSetup.activeSeeds[
          "seed" + (currentSeed + 1)
        ]!;
    }
    if (!brackets.losers.includes(winner)) {
      brackets.losers.push(winner);
    }
  }

  // 12 (Winners)
  if (winnersRoundSet3.includes(currentRound)) {
    if (brackets.winners.includes(loser)) {
      const loserIndex = brackets.winners.indexOf(loser);
      brackets.winners.splice(loserIndex, 1);
    }
    const negativeValue = brackets.losers.indexOf(-1);
    brackets.losers.splice(negativeValue, 1, loser);
    siteData.bracketsModeSettings.currentSeed = 1;
    setSeeds8(siteData, brackets, "losers");
  }

  // 13 (Losers)
  if (currentRound === 13) {
    gameResults.push(loser);
    brackets.losers = [];
    brackets.winners.push(winner);
    siteData.bracketsModeSettings.currentSeed = 1;
    setSeeds8(siteData, brackets, "winners");
  }

  // 14 (Winners) — Final round
  if (currentRound === 14) {
    return { siteData, brackets, isFinal: true };
  }

  siteData.bracketsModeSettings.currentRound += 1;
  return { siteData, brackets, isFinal: false };
}
